var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var GoogleConversionInitializer = /** @class */ (function () {
    function GoogleConversionInitializer() {
        var _this = this;
        this.initializeConversion = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/];
            });
        }); };
    }
    return GoogleConversionInitializer;
}());
var META = "META";
var GADS = "GADS";
var MetaConversionInitializer = /** @class */ (function () {
    function MetaConversionInitializer(pixelId) {
        var _this = this;
        this.initializeConversion = function () { return __awaiter(_this, void 0, void 0, function () {
            var loadFacebookPixel, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!window.fbq) return [3 /*break*/, 5];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, import('./facebookPixelScript')];
                    case 2:
                        loadFacebookPixel = (_a.sent()).loadFacebookPixel;
                        return [4 /*yield*/, loadFacebookPixel()];
                    case 3:
                        _a.sent();
                        window.fbq('init', this.pixelId);
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _a.sent();
                        console.error('Failed to load Facebook Pixel script:', error_1);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        this.pixelId = pixelId;
    }
    return MetaConversionInitializer;
}());
export { MetaConversionInitializer };
var GoogleConversionHandler = /** @class */ (function () {
    function GoogleConversionHandler() {
    }
    GoogleConversionHandler.prototype.handleConversion = function (event) {
        window.gtag && window.gtag('event', 'conversion', { 'send_to': event.config.sendTo });
    };
    return GoogleConversionHandler;
}());
export { GoogleConversionHandler };
var MetaConversionHandler = /** @class */ (function () {
    function MetaConversionHandler() {
    }
    MetaConversionHandler.prototype.handleConversion = function (event) {
        var metaEvent = event.config;
        window.fbq && window.fbq('track', metaEvent.type, metaEvent.payload);
    };
    return MetaConversionHandler;
}());
export { MetaConversionHandler };
var EventProcessor = /** @class */ (function () {
    function EventProcessor(conversionInScope) {
        this.conversionInScope = conversionInScope;
    }
    EventProcessor.prototype.setLookup = function (event) {
        var _a;
        return _a = {},
            _a[GADS] = {
                handler: new GoogleConversionHandler(),
                initializer: new GoogleConversionInitializer(),
            },
            _a[META] = {
                handler: new MetaConversionHandler(),
                initializer: new MetaConversionInitializer(event.pixelId),
            },
            _a;
    };
    EventProcessor.prototype.processEvents = function () {
        return __awaiter(this, void 0, Promise, function () {
            var _i, _a, event;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _i = 0, _a = this.conversionInScope;
                        _b.label = 1;
                    case 1:
                        if (!(_i < _a.length)) return [3 /*break*/, 5];
                        event = _a[_i];
                        this.conversionLookup = this.setLookup(event);
                        this.conversionInitializer = this.conversionLookup[event.tool].initializer;
                        this.conversionHandler = this.conversionLookup[event.tool].handler;
                        if (!(this.conversionInitializer && this.conversionHandler)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.conversionInitializer.initializeConversion(event)];
                    case 2:
                        _b.sent();
                        this.conversionHandler.handleConversion(event);
                        return [3 /*break*/, 4];
                    case 3:
                        // eslint-disable-next-line no-console
                        console.log("No handler or initializer found for tool type: ".concat(event.tool));
                        _b.label = 4;
                    case 4:
                        _i++;
                        return [3 /*break*/, 1];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    return EventProcessor;
}());
export { EventProcessor };
